module.exports = __webpack_public_path__ + "img/point.bc5c618d.gif";